import api from "@/api/axios/axios.js";

export async function getJiraProyectsAll(domain, email, token) {
    try {
        const url = `/login/jira/proyects`;
        const resp = await api.get(url, {
            params: {
                domain, email, token
            }
        });
        const data = await resp.data;
        return data
    } catch (err) {
        return []
    }
}

export async function setIssueHistory(payload) {
    try {
        const url = `/login/jira/issues/`;
        const resp = await api.post(url,
            payload
        );
        const data = await resp.data;
        return data
    } catch (err) {
        console.log(err)
        return { "error": err.response.data.error, "status": err.status }
    }
}

export async function setIssueTestCases(payload) {
    try {
        const url = `/login/jira/issues/testCases/`;
        const resp = await api.post(url, payload)
        const data = await resp.data;
        console.log("WWWWWW ", data)
        return data
    } catch (err) {
        console.log(err)
        return { "error": err.response.data.error, "status": err.status }
    }
}